/* eslint-disable camelcase */
import { createGeneralCall } from '@altermaind/core/requests-status-management';
import { KEY_POST_REFRESH_TOKEN } from '../constants';
import { getRefreshToken } from '../selectors';
import { getAuthSettingsCall } from './getAuthSettingsCall';

export type CallParamsPostRefreshToken = {
  client_id: string;
  grant_type: string;
  refresh_token: string;
};

export const postRefreshTokenCall = createGeneralCall<
  CallParamsPostRefreshToken,
  unknown,
  unknown,
  unknown
>({
  id: KEY_POST_REFRESH_TOKEN,
  url: () => state => {
    const { tokenUrl } = getAuthSettingsCall.selectors.tokenData(state);
    return tokenUrl;
  },
  paramsSelector: () => state => {
    const { client_id } = getAuthSettingsCall.selectors.tokenData(state);
    const token = getRefreshToken(state);
    const body = {
      client_id,
      grant_type: 'refresh_token',
      refresh_token: token,
    };
    return new URLSearchParams(body as never);
  },
  options: {
    bodyHasOriginal: true,
    headers: {
      Origin: `${document.location.origin}`,
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  },
  rsmOptions: {
    doubleRun: false,
  },
  method: 'post',
});
